import React from "react";
import CategoryPage from "./CategoryPage";

const PremiumNumberPlates = () => (
  <CategoryPage
    categoryId="premium-number-plates"
    categoryTitle="Premium Number Plates"
    categoryDescription="High-quality, premium customizable number plates for your vehicle. Durable material, reflective finish, and professional design. Meets all regulatory standards."
  />
);

export default PremiumNumberPlates;
